// PatientPageStyles.js

export const patientPageRootSx = {
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  bgcolor: '#F7F7F7'
};

export const patientPageContentSx = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  p: 1.5,

  scrollbarWidth: 'thin',
  scrollbarColor: '#C5C5C5 transparent',

  '&::-webkit-scrollbar': {
    width: 5
  },

  '&::-webkit-scrollbar-track': {
    background: 'transparent'
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#C5C5C5',
    borderRadius: '10px'
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#A8A8A8'
  }
};

export const patientSearchPopoverPaperSx = {
  width: 500,
  maxWidth: 'calc(100vw - 32px)',
  overflow: 'hidden',
  borderRadius: '6px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)'
};

export const patientSearchInputWrapperSx = {
  p: 2,
  borderBottom: '1px solid #E0E0E0'
};

export const patientSearchIconSx = {
  color: '#9E9E9E',
  fontSize: 20
};

export const patientListSx = {
  maxHeight: 300,
  overflowY: 'auto',

  scrollbarWidth: 'thin',
  scrollbarColor: '#C5C5C5 transparent',

  '&::-webkit-scrollbar': {
    width: 5
  },

  '&::-webkit-scrollbar-track': {
    background: 'transparent'
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#C5C5C5',
    borderRadius: '10px'
  }
};

export const patientListItemSx = {
  px: 2,
  py: 1,
  cursor: 'pointer',
  bgcolor: '#FFFFFF',
  borderBottom: '1px solid #EAEAEA',

  '&:hover': {
    bgcolor: '#FBF7F1'
  }
};

export const patientNameSx = {
  fontSize: 11,
  fontWeight: 500,
  color: '#424242',
  lineHeight: 1.4
};

export const patientDetailsSx = {
  mt: 0.4,
  fontSize: '0.8125rem',
  color: '#424242'
};

export const noPatientsWrapperSx = {
  p: 2
};

export const noPatientsTextSx = {
  fontSize: 13,
  color: '#424242'
};

export const patientSearchFooterSx = {
  px: 2,
  py: 1.5,
  bgcolor: '#FAFAFA'
};

export const patientSearchFooterTextSx = {
  fontSize: 13,
  color: '#424242'
};